import React, { useState, useEffect, useRef } from 'react';

const STEPS = [
  { label: 'Verifying platform agent',   sub: 'Looking up registered DMCA agent…' },
  { label: 'Structuring legal elements', sub: 'Applying 17 U.S.C. § 512(c)(3) requirements…' },
  { label: 'Drafting notice',            sub: 'Writing professionally formatted letter…' },
  { label: 'Ready to download',          sub: 'PDF & email script prepared' },
];

function GeneratingLoader({ isProcessing }) {
  const [activeStep, setActiveStep] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const durations = [800, 1000, 900];
    let step = 0;
    const tick = () => {
      step++;
      if (step <= 2) {
        setActiveStep(step);
        if (step < 2) {
          timerRef.current = setTimeout(tick, durations[step]);
        }
      }
    };
    timerRef.current = setTimeout(tick, durations[0]);
    return () => clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    if (!isProcessing) {
      clearTimeout(timerRef.current);
      setActiveStep(STEPS.length - 1);
    }
  }, [isProcessing]);

  return (
    <div className="processing-state">
      <div className="gen-loader-title">
        <span className="eyebrow-pulse" />
        Generating your notice
      </div>
      <div className="gen-chain">
        {STEPS.map((s, i) => (
          <div className="gen-step-row" key={i}>
            <div className="gen-col">
              <div className={`gen-dot ${i < activeStep ? 'done' : i === activeStep ? 'active' : ''}`}>
                {i < activeStep
                  ? <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
                      <polyline points="2,6 5,9 10,3" stroke="#0d0e10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  : i === activeStep
                  ? <span className="gen-pulse" />
                  : null}
              </div>
              {i < STEPS.length - 1 && (
                <div className={`gen-line ${i < activeStep ? 'lit' : ''}`} />
              )}
            </div>
            <div className="gen-text">
              <span className={`gen-label ${i < activeStep ? 'done' : i === activeStep ? 'active' : ''}`}>
                {s.label}
              </span>
              <span className={`gen-sub ${i < activeStep ? 'done' : i === activeStep ? 'active' : ''}`}>
                {s.sub}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="gen-legal">
        <div className="gen-legal-icon">
          <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
            <polyline points="2,6 5,9 10,3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        17 U.S.C. § 512 compliant structure
      </div>
    </div>
  );
}

export default GeneratingLoader;